module.exports = __webpack_public_path__ + "static/media/b_icon_05.8549a5b9.png";